(function() {
    angular
        .module("app")
        .directive("labelEditor", labelEditor)

    labelEditor.$inject = [
        "$http",
        "$timeout"
    ]

    function labelEditor(
        $http,
        $timeout
    ){
        return {
            restrict: "AE",
            replace: true,
            transclude: true,
            scope: {},
            template: [
                '<div class="label-build">',
                '  <span ng-transclude><button type="button" ng-click="exportHtml()" class="btn btn-default">Save</button></span>',
                '</div>'
            ].join(""),
            link: function(scope, elm, attrs) {
                $timeout(function() {
                    //console.log(elm.html())

                    var highlight
                    highlight = {
                        on: function() {
                            return $(this).css({ "background-color": "silver" })
                        },
                        off: function() {
                            return $(this).css({ "background-color": "transparent" })
                        }
                    }

                    angular.element(elm).find("span").hover(highlight.on, highlight.off)
                    angular.element(elm).find(".label").click(function() {
                        return $(this).prop({ "contentEditable": true })
                    })

                    return angular.element(elm).find("span").draggable(({ grid: [ 5, 5 ] }))
                }, 300)

                scope.exportHtml = function() {
                    console.log(elm.html())
                }
                //$(".label-inner span").hover(highlight.on, highlight.off)
                //$(".label-inner span").click(function() {
                //    return $(this).prop({ "contentEditable": true })
                //})
                //return $(".label-inner span").draggable()

            }
        }
    }
})()
